import React from 'react';

const SvgLogoSa = (props: any) => (
    <svg width={35} height={35} {...props}>
        <g fill="none" fillRule="evenodd">
            <path d="M17.5 0C7.835 0 0 7.835 0 17.5S7.835 35 17.5 35 35 27.165 35 17.5 27.165 0 17.5 0z" fill="#005693" />
            <path
                fill="#FFF"
                d="M26.6 27.252l-.151.848h-6.833l.137-.824 1.596-.357-.468-4.56h-2.063L18.02 28.1h-.962l.852-5.741H16.7l-.798 5.741h-.963l.853-5.741h-2.31l-2.324 4.388 2.275.456-.15.897H7l.136-.834 1.995-.452L21.127 5H22.4l2.685 21.848z"
            />
            <path
                d="M20.65 20.75L19.588 10.6 14 20.75h1.816l.28-1.836c.167-1.133.866-1.565 1.704-1.565 1.09 0 1.565.729 1.565 1.322 0 .783-.531 1.404-1.481 1.404-.391 0-.727-.135-1.006-.35l-.168 1.025h3.94z"
                fill="#005693"
            />
        </g>
    </svg>
);

export default SvgLogoSa;
